import * as XLSX from 'xlsx'
import FileSaver from 'file-saver'

export function downloadExcel(rows, sheetName, fileName, colWidths) {
  const wb = XLSX.utils.book_new()
  const ws = XLSX.utils.json_to_sheet(rows)
  if (colWidths) {
    ws['!cols'] = colWidths
  }
  XLSX.utils.book_append_sheet(wb, ws, sheetName)
  const wbout = XLSX.write(wb, { bookType: 'xlsx', bookSST: true, type: 'array' })
  FileSaver.saveAs(new Blob([wbout], { type: 'application/octet-stream' }), fileName)
}
